<template>
  <div class="switcher">
    <label class="toggle">
      <input
        type="checkbox"
        v-model="isChecked"
        @click.prevent
        :disabled="disabled"
        v-if="preventClick"
      />
      <input type="checkbox" v-model="isChecked" :disabled="disabled" v-else />
      <span class="toggle-slider round" @click="emitClick"></span>
    </label>
    <div class="switcher__label">
      {{ switcherLabel }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Switcher',
  props: {
    label: {
      type: [String, Array],
    },
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    preventClick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isChecked: false,
      initialDataLoaded: false,
    }
  },
  created() {
    this.isChecked = this.checked
    this.$nextTick(() => {
      this.initialDataLoaded = true
    })
  },
  watch: {
    checked(val) {
      this.isChecked = val
    },
    isChecked(val) {
      if (this.disabled) return
      if (this.initialDataLoaded) {
        this.$emit('update:checked', val)
      }
    },
  },
  computed: {
    switcherLabel() {
      if (Array.isArray(this.label)) {
        return this.isChecked ? this.label[0] : this.label[1]
      } else {
        return this.label
      }
    },
  },
  methods: {
    emitClick() {
      if (this.disabled) return
      this.$emit('click')
    },
  },
  emits: ['update:checked', 'click'],
}
</script>

<!--<script>-->
<!--export default {-->
<!--  name: 'Switcher',-->
<!--  // model: {-->
<!--  //   prop: 'checked',-->
<!--  //   event: 'update',-->
<!--  // },-->
<!--  props: {-->
<!--    label: {-->
<!--      type: [String, Array],-->
<!--    },-->
<!--    checked: {-->
<!--      type: Boolean,-->
<!--      default: false,-->
<!--    },-->
<!--    disabled: {-->
<!--      type: Boolean,-->
<!--      default: false,-->
<!--    },-->
<!--    preventClick: {-->
<!--      type: Boolean,-->
<!--      default: false,-->
<!--    },-->
<!--  },-->
<!--  data() {-->
<!--    return {-->
<!--      isChecked: false,-->
<!--      initialDataLoaded: false,-->
<!--    }-->
<!--  },-->
<!--  created() {-->
<!--    this.isChecked = this.checked-->

<!--    this.$nextTick(() => {-->
<!--      this.initialDataLoaded = true-->
<!--    })-->
<!--  },-->
<!--  watch: {-->
<!--    checked: function () {-->
<!--      this.isChecked = this.checked-->
<!--    },-->
<!--    isChecked: function () {-->
<!--      if (this.disabled) {-->
<!--        return-->
<!--      }-->

<!--      if (this.initialDataLoaded) {-->
<!--        // this.$emit('update:value', this.isChecked)-->
<!--        this.$emit('update:checked', newVal)-->
<!--      }-->
<!--    },-->
<!--  },-->
<!--  computed: {-->
<!--    switcherLabel: function () {-->
<!--      if (Array.isArray(this.label)) {-->
<!--        return this.isChecked ? this.label[0] : this.label[1]-->
<!--      } else {-->
<!--        return this.label-->
<!--      }-->
<!--    },-->
<!--  },-->
<!--  methods: {-->
<!--    emitClick: function () {-->
<!--      if (this.disabled) {-->
<!--        return-->
<!--      }-->

<!--      this.$emit('click')-->
<!--    },-->
<!--  },-->
<!--  // emits: ['update', 'update:value', 'click'],-->
<!--  emits: ['update:checked', 'click'],-->
<!--}-->
<!--</script>-->

<style lang="scss" scoped>
.switcher {
  display: flex;
  align-items: center;
  &__label {
    margin-left: 14px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #585f6d;
  }
}
.toggle {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 22px;
}
.toggle input {
  opacity: 0;
  width: 0;
  height: 0;
  display: none;
}
.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  border: 1px solid gray;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.toggle-slider:before {
  position: absolute;
  content: '';
  height: 16px;
  width: 16px;
  left: 1px;
  bottom: 2px;
  background-color: gray;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
input:checked + .toggle-slider {
  background-color: #64748B;
  border-color: #64748B;
}
input:focus + .toggle-slider {
  box-shadow: 0 0 1px #eee;
}
input:checked + .toggle-slider:before {
  -webkit-transform: translateX(12px);
  -ms-transform: translateX(12px);
  transform: translateX(12px);
  background-color: white;
}
.toggle-slider.round {
  border-radius: 34px;
}
.toggle-slider.round:before {
  border-radius: 50%;
}
</style>
